import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import {ConfigService} from "../../services";
import {AppWorkConfig} from "../../models/config.model";

@Component({
  selector: 'app-base',
  template: ''
})
export class BaseComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  workConfig: AppWorkConfig;

  constructor() { }

  ngOnInit(): void {
    this.workConfig = ConfigService.getAppConfig().workConfig;
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  workConfigEnabled(){
    return this.workConfig && this.workConfig.enable;
  }
}
